import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const DataDeletionTenantCell = ({ team }: DataCellProps) => {
  return <Box>{team.tenant}</Box>;
};
